// @ts-nocheck
/* eslint-disable */
import { llaPlatformDiscordIcon } from './discord';
export const socialIcons = [llaPlatformDiscordIcon];
